import React, { lazy } from "react";
import { Redirect } from 'react-router-dom';
import HomeLayout from "src/layouts/HomeLayout";
import DashboardLayout from "src/layouts/DashboardLayout";
export const routes = [

  {
    exact: true,
    path: "/",
    layout: HomeLayout,
    component: lazy(() => import("./view/pages/Auth/Login")),
  },

  {
    exact: true,
    path: "/dashboard",
    layout: DashboardLayout,
    component: lazy(() => import("./view/pages/Dashboard/Index")),
  },
  {
    exact: true,
    path: "/map",
    layout: DashboardLayout,
    component: lazy(() => import("./view/pages/Home/Testing")),
  },
  {
    exact: true,
    path: "/employee",
    layout: DashboardLayout,
    component: lazy(() => import("./view/pages/Dashboard/Employee/Employee")),
  },

  // {
  //   exact: true,
  //   path: "/employee_profile",
  //   layout: DashboardLayout,
  //   component: lazy(() => import("./view/pages/Dashboard/Employee/EmpProfile")),
  // },
  {
    exact: true,
    path: "/profile",
    layout: DashboardLayout,
    component: lazy(() => import("./view/pages/Dashboard/Profile")),
  },
  {
    exact: true,
    path: "/testmode",
    layout: DashboardLayout,
    component: lazy(() => import("./view/pages/TestMode")),
  },
  {
    exact: true,
    path: "/attendance",
    layout: DashboardLayout,
    component: lazy(() => import("./view/pages/Dashboard/Attendance/Attendance")),
  },
  {
    exact: true,
    path: "/employee_dashboard",
    layout: DashboardLayout,
    component: lazy(() => import("./view/pages/EmpDashboard/Index")),
  },
  {
    exact: true,
    path: "/employee_attendance",
    layout: DashboardLayout,
    component: lazy(() => import("./view/pages/EmpDashboard/EmpAttendance/EmpAttendance")),
  },
  {
    exact: true,
    path: "/payroll",
    layout: DashboardLayout,
    component: lazy(() => import("./view/pages/Dashboard/payroll/index")),
  },
  {
    exact: true,
    path: "/salarylist",
    layout: DashboardLayout,
    component: lazy(() => import("./view/pages/Dashboard/payroll/Salarylist")),
  },
  {
    exact: true,
    path: "/employeesalary",
    layout: DashboardLayout,
    component: lazy(() => import("./view/pages/Dashboard/payroll/Employeelist")),
  },
  {
    exact: true,
    path: "/leaves",
    layout: DashboardLayout,
    component: lazy(() => import("./view/pages/Dashboard/Leaves/index")),
  },
  {
    exact: true,
    path: "/employee_leaves",
    layout: DashboardLayout,
    component: lazy(() => import("./view/pages/Dashboard/Leaves/Empleave")),
  },
  // {
  //   exact: true,
  //   path: "/leaves_apply",
  //   layout: DashboardLayout,
  //   component: lazy(() => import("./view/pages/Dashboard/Leaves/EmpapplyLeave")),
  // },
  {
    exact: true,
    path: "/login_activity",
    layout: DashboardLayout,
    component: lazy(() => import("./view/pages/EmpDashboard/LoginActivity/index")),
  },
  {
    exact: true,
    path: "/emp_login_activity",
    layout: DashboardLayout,
    component: lazy(() => import("./view/pages/Dashboard/Emploginactivity.js")),
  },

  {
    exact: true,
    path: "/breaktime",
    layout: DashboardLayout,
    component: lazy(() => import("./view/pages/EmpDashboard/EmpBreakTime/EmpBreaktime")),
  },
  {
    exact: true,
    path: "/holiday",
    layout: DashboardLayout,
    component: lazy(() => import("./view/pages/Dashboard/Holiday/Index")),
  },
  {
    exact: true,
    path: "/policies",
    layout: DashboardLayout,
    component: lazy(() => import("./view/pages/Dashboard/Policies/index")),
  },
  {
    exact: true,
    path: "/designation",
    layout: DashboardLayout,
    component: lazy(() => import("./view/pages/Dashboard/Designation/Index")),
  },
  {
    exact: true,
    path: "/allbreak",
    layout: DashboardLayout,
    component: lazy(() => import("./view/pages/EmpDashboard/EmpBreakTime/Allbreak")),
  },
  {
    exact: true,
    path: "/allextrabreak",
    layout: DashboardLayout,
    component: lazy(() => import("./view/pages/EmpDashboard/EmpBreakTime/Allextrabreak")),
  },
  {
    exact: true,
    path: "/allemp_break",
    layout: DashboardLayout,
    component: lazy(() => import("./view/pages/Dashboard/BreakTime/Allempbreak")),
  },

  {
    component: () => <Redirect to="/404" />,
  },
];
